import React from 'react';
export const hello = [
    'Hello',
    'Hola',
    '你好',
    'Hallo',
    'Përshëndetje',
    'ሰላም',
    'أهلا',
    'Բարեւ Ձեզ',
    'Salam',
    'Kaixo',
    'добры дзень',
    'হ্যালো',
    'Zdravo',
    'Здравейте',
    'Kumusta',
    'Moni',
    'Bonghjornu',
    'Ahoj',
    'Hej',
    'Saluton',
    'Tere',
    'Kamusta',
    'Hei',
    'Bonjour',
    'Ola',
    'გამარჯობა',
    'γεια σας',
    'નમસ્તે',
    'Bonjou',
    'Sannu',
    'Aloha',
    'שלום',
    'नमस्ते',
    'Nyob zoo',
    'Helló',
    'Nnọọ',
    'Dia dhuit',
    'Ciao',
    'こんにちは',
    'ನಮಸ್ಕಾರ',
    'Сәлеметсіз бе',
    'សួស្តី',
    'Mwaramutse',
    '안녕하십니까',
    'Slav',
    'салам',
    'ສະບາຍດີ',
    'Salve',
    'Sveiki',
    'Здраво',
    'Salama',
    'ഹലോ',
    'Bongu',
    'Kia ora',
    'नमस्कार',
    'Сайн уу',
    'မင်္ဂလာပါ',
    'नमस्कार',
    'ନମସ୍କାର',
    'سلام',
    'dzień dobry',
    'Olá',
    'ਸਤ ਸ੍ਰੀ ਅਕਾਲ',
    'Buna ziua',
    'Привет',
    'Talofa',
    'Здраво',
    'Lumela',
    'Mhoro',
    'هيلو',
    'ආයුබෝවන්',
    'Ahoj',
    'Салом',
    'வணக்கம்',
    'Сәлам',
    'హలో',
    'สวัสดี',
    'Merhaba',
    'Здравствуйте',
    'ہیلو',
    'ياخشىمۇسىز',
    'Salom',
    'Xin chào',
    'Mholweni',
    'העלא',
    'Pẹlẹ o',
    'Sawubona'
];